<template>
  <div class="number-card-list">
    <slot />
  </div>
</template>
<script>
export default {
  name: "NumberCardList",
};
</script>
<style lang="scss">
.number-card-list {
  @include auto_margin_top(20px);
  @include flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-left: -10px;
  margin-right: -10px;
  .task-number-card,
  .alert-number-card,
  .number-card {
    margin: 10px;
    width: calc((100% - 80px) / 4);
    @media screen and (max-width: 1023px) {
      width: calc((100% - 40px) / 2);
    }
  }
}
</style>